var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-content"},[_c('div',{staticClass:"game-logo"}),_c('div',{staticClass:"bar-box"},[_c('div',{staticClass:"bar"},[_c('span',{style:({'width': _vm.width + '%'})})]),_c('p',[_vm._v(_vm._s(_vm.width)+"%")])]),_c('div',{staticClass:"ts-text"},[_vm._v("正在為您跳轉遊戲界面，請稍候…")])])
}
var staticRenderFns = []

export { render, staticRenderFns }